import { combineReducers } from '@reduxjs/toolkit';
import { swatchesReducer } from '../../features/swatches/model/swatchesSlice';
import { cartReducer } from '../../features/Cart/model/cartSlice';
import { multiProductCartReducer } from '../../features/MultiProduct/model/multiProductCartSlice';

const rootReducer = combineReducers({
  swatches: swatchesReducer,
  cart: cartReducer,
  multiProductCart: multiProductCartReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
